"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPLETED_MOCK_TESTS_FRAGMENT = exports.COMPLETED_MOCK_TEST_MARKSHEET_FRAGMENT = exports.MARK_FLAGGED_QUESTION = exports.MOCK_TEST_FIELDS = void 0;
const client_1 = require("@apollo/client");
exports.MOCK_TEST_FIELDS = (0, client_1.gql) `
  fragment MockTestFields on MockTest {
    id
    demo
    title
    intro
    passingMark
    correct
    incorrect
    totalQuestions
    lastMarksheetEndedAt
    lastMarksheetStartedAt
    lastMarksheetId
    typeId
  }
`;
/**
 * All below fragments are used in cache updator
 */
exports.MARK_FLAGGED_QUESTION = (0, client_1.gql) `
  fragment MarksheetMarkFlagged on MarksheetMark {
    flagged
  }
`;
exports.COMPLETED_MOCK_TEST_MARKSHEET_FRAGMENT = (0, client_1.gql) `
  fragment MockTestCompleted on Marksheet {
    completed
    correct
    timeTaken
    incorrect
    duration
    endedAt
  }
`;
exports.COMPLETED_MOCK_TESTS_FRAGMENT = (0, client_1.gql) `
  fragment CompletedMockTestFragment on MockTest {
    correct
    incorrect
    lastMarksheetEndedAt
    lastMarksheetStartedAt
    lastMarksheetId
  }
`;
